






import { Component, Vue } from "vue-property-decorator";
import Portfolio from "./components/Portfolio.vue";

@Component({
  components: {
    Portfolio
  }
})
export default class App extends Vue {}
